import styled from 'styled-components';

export const StyledPreferenceCard = styled.div`
  border: 1px solid
    ${props =>
      props.error
        ? props.theme.colors.status.errorPrimary
        : props.theme.colors.border.base};
  border-radius: 8px;
  width: 100%;
  margin: 8px 0;
`;

export const Heading = styled.div`
  background-color: ${props => props.theme.colors.background.base};
  border-radius: 8px 8px 0px 0px;
  padding: 16px;
`;

export const HeaderTwo = styled.h2`
  font-size: 1.125rem;
  color: ${props =>
    props.error
      ? props.theme.colors.status.errorPrimary
      : props.theme.colors.text.primary};
  @media ${props => props.theme.tabletS} {
    font-size: 1.25rem;
  }
`;

export const Paragraph = styled.p`
  font-size: 0.875rem;
`;

export const Content = styled.div`
  padding: 16px;
  font-size: 0.875rem;
`;
